import { render, staticRenderFns } from "./QError.vue?vue&type=template&id=1c869521&scoped=true"
import script from "./QError.vue?vue&type=script&lang=ts"
export * from "./QError.vue?vue&type=script&lang=ts"
import style0 from "./QError.vue?vue&type=style&index=0&id=1c869521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c869521",
  null
  
)

export default component.exports